module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-hu.a7a06830588153a3e278.svg";